import { type FilterItem } from 'widgets/FilterEditor/model'

export const isContactWidget = (filterItem: FilterItem) =>
  filterItem.type === 'select_for_conversation_contact' &&
  !!filterItem.config.is_values_required &&
  !filterItem.config.hasOwnProperty('values')
